<template>
  <v-dialog v-model="dialog" max-width="500" persistent>
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-on="on"
        v-bind="attrs"
        color="secondary"
        class="font-weight-bold"
        dark
        rounded
        :block="isMobile()"
        outlined
        ><v-icon left>mdi-plus</v-icon>Adicionar autorizado
      </v-btn>
    </template>
    <v-card>
      <v-card-title
        class="green lighten-4 primary--text text-darken-4 font-weight-bold"
        >Adicionar autorizado</v-card-title
      >
      <v-card-text>
        <v-form ref="form" class="mt-6">
          <v-text-field
            label="Digite o CPF que você quer autorizar"
            outlined
            class="campo-cpf-autorizado"
            autofocus
            v-model="pesquisarCpfModel"
            v-mask="'###########'"
            hide-details=""
          ></v-text-field>
          <v-btn
            class="mt-2"
            depressed
            color="info"
            block
            :loading="consultandoCpf"
            @click="consultarCpf()"
            :disabled="cpfPesquisar.length != 11"
          >
            <v-icon left>mdi-magnify</v-icon>Consultar</v-btn
          >
          <v-alert
            type="error"
            text
            dense
            class="subtitle-1 mt-2"
            v-if="cpf_consultado.msg != ''"
            >{{ cpf_consultado.msg }}</v-alert
          >
        </v-form>
        <v-list-item class="mt-4 grey lighten-4 rounded-md">
          <v-list-item-content>
            <v-list-item-subtitle>Nome</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold">{{
              cpf_consultado.nome != ""
                ? cpf_consultado.nome
                : "---------------"
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item class="mt-2 grey lighten-4 rounded-md">
          <v-list-item-content>
            <v-list-item-subtitle>Data nascimento</v-list-item-subtitle>
            <v-list-item-title class="font-weight-bold">{{
              cpf_consultado.data_nasc != ""
                ? formatarData(cpf_consultado.data_nasc)
                : "---------------"
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-row class="mt-2">
          <v-col cols="6">
            <v-btn
              rounded
              color="success"
              block
              :disabled="!cpf_consultado.valido"
              :loading="criandoAutorizado"
              @click="criar()"
              >Confirmar</v-btn
            >
          </v-col>
          <v-col cols="6">
            <v-btn
              rounded
              @click="dialog = false"
              color="grey"
              dark
              block
              :disabled="criandoAutorizado"
              >Cancelar</v-btn
            >
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import { dateFormat } from "@/global";
export default {
  watch: {
    dialog: function (open) {
      if (open) {
        this.setCpfPesquisar("");
        this.setCpfConsultado({
          nome: "",
          data_nasc: "",
          valido: false,
          msg: "",
        });
      }
    },
  },
  computed: {
    ...mapState("configComprasPrazo", [
      "cpfPesquisar",
      "cpf_consultado",
      "consultandoCpf",
      "criandoAutorizado",
    ]),
    pesquisarCpfModel: {
      get: function () {
        return this.cpfPesquisar;
      },
      set: function (value) {
        if (value.length < 11)
          this.setCpfConsultado({
            nome: "",
            data_nasc: "",
            valido: false,
            msg: "",
          });
        this.setCpfPesquisar(value);
      },
    },
  },
  data: () => ({
    dialog: false,
  }),
  methods: {
    ...mapMutations("configComprasPrazo", [
      "setCpfPesquisar",
      "setCpfConsultado",
    ]),
    ...mapActions("configComprasPrazo", [
      "consultarCpf",
      "criarAutorizado",
      "carregarAutorizados",
    ]),
    formatarData(value) {
      return dateFormat(value);
    },
    isMobile() {
      return this.$mq == "sm";
    },
    async criar() {
      var ret = await this.criarAutorizado();
      if (ret) {
        this.dialog = false;
        await this.carregarAutorizados();
      }
    },
  },
};
</script>

<style>
.campo-cpf-autorizado input {
  letter-spacing: 5px !important;
  font-family: "archivo black" !important;
  font-size: 1.3rem !important;
}
</style>